<script lang="ts">
  import { codeData } from './modals';

  let onConfirm: Function | null = null;

  codeData.subscribe((value) => {
    if (value && value.callback) {
      onConfirm = value.callback;
    } else {
      onConfirm = null;
    }
  });

  const confirm = () => {
    if (onConfirm) {
      onConfirm();
    }
    codeData.set(null);
  };
</script>

{#if $codeData}
  <div class="modal-container">
    <div class="modal">
      {#if $codeData.title}
        <div class="header">
          <h1>{$codeData.title}</h1>
        </div>
      {/if}

      {#if $codeData.text}
        <div class="body">
          <pre>{$codeData.text}</pre>
        </div>
      {/if}

      <div class="functions">
        <button class="btn" onclick={confirm}>Confirm</button>
      </div>
    </div>
  </div>
{/if}

<style lang="less">
  .modal-container {
    .modal {
      .body {
        text-align: left;
      }
    }
  }
</style>
